module.exports = __webpack_public_path__ + "img/Tablo.fdf11a8.png";